/* ====================================================================
   DM - Wunschliste (PROJ-56)
   localStorage-Wunschliste ohne App: Herz-Toggle (Karte/PDP),
   Header-Dot, Wunschlisten-Seite inkl. Teilen (Link/WhatsApp) und
   geteilter Ansicht (?items=handle,handle).
   ==================================================================== */
(function () {
  'use strict';

  /* Doppel-Einbindung (Header global + Section) nur einmal ausführen */
  if (window.__dlWishlistLoaded) return;
  window.__dlWishlistLoaded = true;

  var KEY = 'dl_wishlist';
  var PAGE_URL = '/pages/wunschliste';

  /* ---------- Storage ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* Privat-Modus: leise scheitern */ }
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    if (!handle) return false;
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
    write(list);
    return i === -1;
  }

  /* ---------- UI-Sync ---------- */
  function syncButtons() {
    var list = read();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var on = list.indexOf(btn.getAttribute('data-product-handle')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Von der Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
    }
  }
  function syncDot() {
    var count = read().length;
    var dots = document.querySelectorAll('[data-wishlist-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-visible', count > 0);
      dots[i].textContent = count > 0 ? (count > 99 ? '99+' : String(count)) : '';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-product-handle'));
  });

  document.addEventListener('wishlist:changed', function () {
    syncButtons();
    syncDot();
  });
  document.addEventListener('shopify:section:load', function () {
    syncButtons();
    syncDot();
  });

  /* ---------- Wunschlisten-Seite ---------- */
  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function minPrice(product) {
    var min = null;
    (product.variants || []).forEach(function (v) {
      if (min === null || v.price < min) min = v.price;
    });
    return min === null ? product.price : min;
  }

  function cardHTML(product) {
    var img = product.featured_image
      ? '<img class="product-card__image product-card__image--primary" src="' + product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy">'
      : '';
    return (
      '<product-card class="product-card">' +
        '<div class="product-card__figure">' +
          '<a href="/products/' + product.handle + '" class="product-card__media">' + img + '</a>' +
          '<button type="button" class="wishlist-button wishlist-button--card" data-wishlist-toggle data-product-handle="' + product.handle + '" aria-pressed="true" aria-label="Von der Wunschliste entfernen">' +
            heartSVG() +
          '</button>' +
        '</div>' +
        '<div class="product-card__info">' +
          '<div class="v-stack justify-items-center gap-1">' +
            '<a href="/products/' + product.handle + '" class="product-title">' + escapeHTML(product.title) + '</a>' +
            '<p class="price-list justify-center" style="margin:0">ab ' + formatPrice(minPrice(product)) + '</p>' +
          '</div>' +
        '</div>' +
      '</product-card>'
    );
  }

  function heartSVG() {
    return '<svg aria-hidden="true" fill="none" focusable="false" width="20" class="wishlist-button__icon icon" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function escapeHTML(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function shareIconLink() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function shareIconWhatsApp() {
    return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35Z"/><path d="M12.05 2C6.58 2 2.13 6.45 2.13 11.92c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.8 1.22h.01c5.46 0 9.91-4.45 9.91-9.92A9.86 9.86 0 0 0 12.05 2Zm0 18.17h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24a8.2 8.2 0 0 1 8.24 8.25c0 4.54-3.7 8.23-8.24 8.23Z"/></svg>';
  }

  function renderPage() {
    var mount = document.getElementById('wishlist-page-content');
    if (!mount) return;

    var params = new URLSearchParams(location.search);
    var sharedParam = params.get('items');
    var isShared = !!sharedParam;
    var handles = isShared
      ? sharedParam.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 50)
      : read();

    var titleEl = document.querySelector('[data-wishlist-title]');
    if (isShared && titleEl) titleEl.textContent = 'Geteilte Wunschliste';

    if (handles.length === 0) {
      mount.innerHTML =
        '<div class="wishlist-page__empty">' +
          '<p>' + (mount.getAttribute('data-empty-text') || 'Deine Wunschliste ist noch leer. Tippe auf das Herz bei einem Produkt, um es dir zu merken.') + '</p>' +
          '<a class="wishlist-share-btn" href="' + (mount.getAttribute('data-empty-link') || '/collections/bestseller') + '">' + (mount.getAttribute('data-empty-cta') || 'Bestseller entdecken') + '</a>' +
        '</div>';
      return;
    }

    mount.innerHTML = '<div class="wishlist-page__grid" data-wishlist-grid></div>';
    var grid = mount.querySelector('[data-wishlist-grid]');

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var found = products.filter(Boolean);

      /* Selbstheilung: geloeschte/Draft-Produkte still aus der eigenen Liste raeumen */
      if (!isShared && found.length !== handles.length) {
        var valid = found.map(function (p) { return p.handle; });
        write(read().filter(function (h) { return valid.indexOf(h) > -1; }));
      }

      if (found.length === 0) {
        mount.innerHTML = '<div class="wishlist-page__empty"><p>Diese Produkte sind leider nicht mehr verfügbar.</p></div>';
        return;
      }

      grid.innerHTML = found.map(cardHTML).join('');

      /* Teilen-Block bzw. Uebernehmen-Button */
      var actions = document.createElement('div');
      actions.className = 'wishlist-page__share';

      if (isShared) {
        var adopt = document.createElement('button');
        adopt.type = 'button';
        adopt.className = 'wishlist-share-btn';
        adopt.textContent = '♥ In meine Wunschliste übernehmen';
        adopt.addEventListener('click', function () {
          var merged = read();
          found.forEach(function (p) { if (merged.indexOf(p.handle) === -1) merged.push(p.handle); });
          write(merged);
          location.href = PAGE_URL;
        });
        actions.appendChild(adopt);
        var note = document.createElement('p');
        note.className = 'wishlist-page__shared-note';
        note.textContent = 'Diese Wunschliste wurde mit dir geteilt.';
        mount.insertBefore(note, grid);
      } else {
        var shareURL = location.origin + PAGE_URL + '?items=' + found.map(function (p) { return p.handle; }).join(',');
        var shareText = 'Schau mal, meine Wunschliste bei Distantlines:';

        var copy = document.createElement('button');
        copy.type = 'button';
        copy.className = 'wishlist-share-btn';
        copy.innerHTML = shareIconLink() + '<span>Link kopieren</span>';
        copy.addEventListener('click', function () {
          var done = function () {
            copy.querySelector('span').textContent = 'Link kopiert ✓';
            setTimeout(function () { copy.querySelector('span').textContent = 'Link kopieren'; }, 2000);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(shareURL).then(done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = shareURL; document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta); done();
          }
        });

        var wa = document.createElement('a');
        wa.className = 'wishlist-share-btn';
        wa.href = 'https://wa.me/?text=' + encodeURIComponent(shareText + ' ' + shareURL);
        wa.target = '_blank';
        wa.rel = 'noopener';
        wa.innerHTML = shareIconWhatsApp() + '<span>Per WhatsApp teilen</span>';

        actions.appendChild(copy);
        actions.appendChild(wa);
      }

      mount.appendChild(actions);
    });
  }

  /* Auf der eigenen Liste: Karte nach Entfernen ausblenden */
  document.addEventListener('wishlist:changed', function () {
    var mount = document.getElementById('wishlist-page-content');
    if (!mount || new URLSearchParams(location.search).get('items')) return;
    var list = read();
    var cards = mount.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < cards.length; i++) {
      var handle = cards[i].getAttribute('data-product-handle');
      if (list.indexOf(handle) === -1) {
        var card = cards[i].closest('product-card');
        if (card) card.remove();
      }
    }
    if (list.length === 0) renderPage();
  });

  /* ---------- Init ---------- */
  function init() {
    syncButtons();
    syncDot();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
